module.exports = __webpack_public_path__ + "img/责任.2514f785.png";